import React from 'react';
import PropTypes from 'prop-types';

import styles from './List.scss';

class List extends React.PureComponent {
  render() {
    const {
      groupType,
      children,
      allowXAxisScroll,
      virtualized,
      containerHeight,
      listHeader,
    } = this.props;
    const containerStyle = virtualized
      ? { height: containerHeight }
      : undefined;
    return (
      <div
        className={`List List--${groupType} ${
          virtualized ? ' List--virtualized' : ''
        }${allowXAxisScroll ? ' List--x-axis-scroll' : ''}`}
      >
        <div className="List__container" style={containerStyle}>
          <div className="List__header">{listHeader}</div>
          <div className="List__rows">{children}</div>
        </div>
      </div>
    );
  }
}

List.propTypes = {
  virtualized: PropTypes.bool,
  groupType: PropTypes.oneOf(['school', 'class', 'stats']).isRequired,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array])
    .isRequired,
  allowXAxisScroll: PropTypes.bool,
  containerHeight: PropTypes.string,
  listHeader: PropTypes.element,
};

List.defaultProps = {
  allowXAxisScroll: false,
  virtualized: false,
};

export default List;
